import Button from './Button'
export  default  Button



// WEBPACK FOOTER //
// ./components/Button/index.js